import React from "react";
import { DEX_URL } from "../../config/app.config";
import "./BottomNav.css";

const TABS = [
  { key: "home", label: "Home", icon: HomeIcon },
  { key: "packages", label: "Packages", icon: PackagesIcon },
  { key: "team", label: "Team", icon: TeamIcon },
  { key: "scn", label: "SCN", icon: ScnIcon },
  { key: "swap", label: "Swap", icon: SwapIcon, href: DEX_URL },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner">
        {TABS.map((t) => {
          const Icon = t.icon;
          const on = active === t.key;

          // External link (opens the DEX) vs internal tab switch.
          if (t.href) {
            return (
              <a
                key={t.key}
                className="nav-tab"
                href={t.href}
                target="_blank"
                rel="noreferrer"
              >
                <span className="nav-ico"><Icon /></span>
                <span className="nav-text">{t.label}</span>
              </a>
            );
          }

          return (
            <button
              key={t.key}
              className={`nav-tab ${on ? "active" : ""}`}
              onClick={() => onChange(t.key)}
            >
              <span className="nav-ico"><Icon active={on} /></span>
              <span className="nav-text">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

function SwapIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 8h13l-3.5-3.5" />
      <path d="M20 16H7l3.5 3.5" />
    </svg>
  );
}

/* ---- inline SVG icons (stroke uses currentColor) ---- */
function HomeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
    </svg>
  );
}
function PackagesIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 8l-9-5-9 5 9 5 9-5z" />
      <path d="M3 8v8l9 5 9-5V8" />
      <path d="M12 13v8" />
    </svg>
  );
}
function TeamIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
      <circle cx="17.5" cy="9" r="2.4" />
      <path d="M16 20c0-2.4 1.6-4.2 4-4.5" />
    </svg>
  );
}
function ScnIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9.5c-.6-1-1.8-1.6-3-1.6-1.7 0-3 1-3 2.3 0 3 6 1.6 6 4.6 0 1.4-1.4 2.3-3 2.3-1.3 0-2.5-.6-3.1-1.6" />
      <path d="M12 6.2v1.6M12 16.2v1.6" />
    </svg>
  );
}
